import React, { Component } from "react";
import {
  Tab,
  Tabs,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";
import { Field, reduxForm } from "redux-form";
import { Link, Prompt } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import Cards from "react-credit-cards";
import "react-credit-cards/es/styles-compiled.css";
import OrderDetail from "./orderDetail";
import {
  fetchUserToken,
  fetchRegion,
  fetchPlace,
  fetchRegionPrice,
} from "../../redux/actions";
import {
  renderTextField,
  renderCheckBoxField,
  renderRadioButton,
  renderTextAreaField,
  renderDropdownField,
} from "./renderCollection";

let sendAllItem = false;

console.log("Inside ListForm.js");

class ListForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      regionList: [],
      subRegionList: [],
      number: "",
      isValid: false,
      name: "",
      expiry: "",
      isCopy: false,
      isReceipt: false,

      // subRegionValue='Aberdeen'
    };
  }

  componentDidMount() {
    if (_.isEmpty(this.props.userToken)) {
      this.props.fetchUserToken();
    }

    this.getRegionItem();

    this.setState({
      loading: false,
    });
    this.props.fetchRegionPrice("Aberdeen");
  }

  getRegionItem = () => {
    // region
    this.props.fetchRegion().then((response) => {
      let responseData = response.payload.data;
      this.setState({
        regionList: responseData,
      });
    });

    // subRegion
    this.props.fetchPlace().then((response) => {
      let responseData = response.payload.data;
      this.setState({
        subRegionList: responseData,
      });
    });
  };

  getTodayDate() {
    let today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();

    today = yyyy + "-" + mm + "-" + dd;

    // date must be in  (yyyy-mm-dd ) format or else will not parse

    return today;
  }
  onSubmit = (value, dispatch, error) => {
    if (!this.props.valid) {
      alert("Please fill out all the information");
      return;
    }
    if (!this.state.isValid) {
      alert("Please enter the correct credit card number");
    } else {
      if (!sendAllItem) {
        let shoppingCartItems = JSON.parse(
          localStorage.getItem("shoppingCartItems")
        );
        _.map(shoppingCartItems, (item, index) => {
          value["recipientCompany" + (index + 1)] = document.getElementsByName(
            "recipientCompany" + (index + 1)
          )[0].value;
          value["deliveryDate" + (index + 1)] = document.querySelector(
            "#deliveryDate" + (index + 1)
          ).value;
          let deliveryTime = document.querySelector(
            "#deliveryTime" + (index + 1)
          );
          value["deliveryTime" + (index + 1)] =
            deliveryTime.options[deliveryTime.selectedIndex].value;

          let subRegion = document.querySelector("#subRegion" + (index + 1));
          let subRegionValue = subRegion.options[subRegion.selectedIndex].value;
          value["subRegionValue" + (index + 1)] = subRegionValue;
          value.cardNumber = this.state.number;
          console.log("value card holder name " + value.cardholderName);
          value.cardholderName = this.state.name;
          console.log("value card holder name " + this.state.name);
          value.expiry = this.state.expiry;
          value.isCopy = this.state.isCopy;

          console.log("2JO **** isReciept " + value.isReceipt);
          value.isReceipt = this.state.isReceipt;
        });
        localStorage.setItem("orderListContactDetail", JSON.stringify(value));
      } else {
        value.recipientCompany =
          document.getElementsByName("recipientCompany")[0].value;
        value.deliveryDate = document.querySelector("#deliveryDate").value;
        console.log("Earlier value delivery date " + value.deliveryDate);
        let deliveryTime = document.querySelector("#deliveryTime");
        value.deliveryTime =
          deliveryTime.options[deliveryTime.selectedIndex].value;
        let subRegion = document.querySelector("#subRegion");
        let subRegionValue = subRegion.options[subRegion.selectedIndex].value;

        value.subRegionValue = subRegionValue;
        value.cardNumber = this.state.number;
        value.cardholderName = this.state.name;
        value.expiry = this.state.expiry;
        value.isCopy = this.state.isCopy;
        value.isReceipt = this.state.isReceipt;
        console.log("1JO **** isReciept " + value.isReceipt);
        localStorage.setItem("orderListContactDetail", JSON.stringify(value));
      }
      this.props.redirectToSubmitPage();
    }
  };

  renderNameSection = (caption, prefix) => {
    const genderdropdown = [
      { value: "Mr", display: "Mr." },
      { value: "Ms.", display: "Ms." },
    ];

    return (
      <div className="form-group">
        <label> {caption} </label>
        <br />
        <div className="NameSetionContainer">
          <Field
            className="form-control"
            dynamicClass="TitleDropDown"
            name={`${prefix}title`}
            withLabel={false}
            options={genderdropdown}
            component={renderDropdownField}
          />
          {/*<Field*/}
          {/*  className="form-control"*/}
          {/*  dynamicClass="NameInput"*/}
          {/*  placeholder="First Name"*/}
          {/*  name={`${prefix}firstName`}*/}
          {/*  withLabel={false}*/}
          {/*  component={renderTextField}*/}
          {/*/>*/}
          {/*<Field*/}
          {/*  className="form-control"*/}
          {/*  dynamicClass="NameInput"*/}
          {/*  placeholder="Last Name"*/}
          {/*  name={`${prefix}lastName`}*/}
          {/*  withLabel={false}*/}
          {/*  component={renderTextField}*/}
          {/*/>*/}
          <Field
            dynamicClass="NameInput"
            placeholder="Display Name"
            name={`${prefix}DisplayName`}
            withLabel={false}
            component={renderTextField}
          />
        </div>
      </div>
    );
  };

  renderPaymentMethodSection = (caption) => {
    return (
      <div className="PaymentMethodSection form-group">
        <label> {caption} </label>
        <div className="form-group">
          <Field
            className="form-control"
            dynamicClass="PaymentMethodInput"
            name="paymentMethod"
            value="visa"
            label="Visa"
            component={renderRadioButton}
          />
          <Field
            className="form-control"
            dynamicClass="PaymentMethodInput"
            name="paymentMethod"
            value="masterCard"
            label="MasterCard"
            component={renderRadioButton}
          />
          <Field
            className="form-control"
            dynamicClass="PaymentMethodInput"
            name="paymentMethod"
            value="americanExpress"
            label="American Express"
            component={renderRadioButton}
          />
        </div>
      </div>
    );
  };

  renderCardNumberSection = (caption) => {
    return (
      <div className="CardNumberSection form-group">
        <label>{caption}</label>
        <div className="form-group">
          <Field
            id="cardNumber1"
            className="form-control"
            name={`cardNumber`}
            withLabel={true}
            component={renderTextField}
          />
        </div>
      </div>
    );
  };

  handleSelectItemTab = (eventKey) => {};

  handleCopyOrder = () => {
    this.setState((prevState) => {
      return {
        isCopy: !prevState.isCopy,
      };
    });
  };

  handleOfficialReceipt = () => {
    this.setState((prevState) => {
      console.log("prevState " + prevState);
      return {
        isReceipt: !prevState.isReceipt,
      };
    });
  };

  toggleSendAllItem = () => {
    let tab = document.querySelector(".nav-tabs");

    if (!sendAllItem) {
      sendAllItem = true;
      this.forceUpdate();
      tab.style.display = "none";
    } else {
      sendAllItem = false;
      this.forceUpdate();
      tab.style.display = "block";
    }
  };
  handleInputFocus = ({ target }) => {
    this.setState({
      focused: target.name,
    });
  };

  handleInputChange = ({ target }) => {
    if (target.name === "number") {
      this.setState({
        [target.name]: target.value.replace(/ /g, ""),
      });
    } else if (target.name === "expiry") {
      this.setState({
        [target.name]: target.value.replace(/ |\//g, ""),
      });
    } else {
      this.setState({
        [target.name]: target.value,
      });
    }
  };
  handleCallback = (type, isValid) => {
    if (isValid) this.setState({ isValid });
    else this.setState({ isValid });
  };
  getRegionDeliveryPrice = (e) => {
    console.log(e.target.value);
    this.props.fetchRegionPrice(e.target.value);
  };
  render() {
    if (this.state.loading) {
      return <div>Loading...</div>;
    }
    console.log(this.props);
    const { handleSubmit, valid } = this.props;

    let shoppingCartItems = JSON.parse(
      localStorage.getItem("shoppingCartItems")
    );
    let tabItem = [];
    if (!_.isEmpty(shoppingCartItems)) {
      if (!shoppingCartItems.includes("empty")) {
        let regionListItem = [];
        _.map(this.state.regionList, (item, index) => {
          regionListItem.push(
            <option key={index} value={item}>
              {item}
            </option>
          );
        });

        let subRegionListItem = [];
        _.map(this.state.subRegionList, (item, index) => {
          subRegionListItem.push(
            <option key={index} value={item}>
              {item}
            </option>
          );
        });

        _.map(shoppingCartItems, (item, index) => {
          let recipientSectionForm = null;
          if (!sendAllItem) {
            recipientSectionForm = (
              <div id="RecipientSection">
                {/*<Field*/}
                {/*  name="oneRecipient"*/}
                {/*  label="Same recipient's details for all items"*/}
                {/*  component={renderCheckBoxField}*/}
                {/*  onChange={this.toggleSendAllItem}*/}
                {/*/>*/}
                <Field
                  name="oneRecipient"
                  label="Send me a copy of the order"
                  component={renderCheckBoxField}
                  onChange={this.handleCopyOrder}
                />
                <Field
                  name="oneRecipient"
                  label="Email official reciept"
                  component={renderCheckBoxField}
                  onChange={this.handleOfficialReceipt}
                />
                {this.renderNameSection(
                  "* Recipient's Name",
                  "recipient" + (index + 1)
                )}
                <Field
                  title="* Phone"
                  name={"recipientPhone" + (index + 1)}
                  withLabel={true}
                  component={renderTextField}
                />
                <Field
                  title="Company"
                  name={"recipientCompany" + (index + 1)}
                  withLabel={true}
                  component={renderTextField}
                />
                <div className="form-group DeliveryDate">
                  <label>* Delivery Date</label>
                  <input
                    id={"deliveryDate" + (index + 1)}
                    className="form-control"
                    type="date"
                    name="deliveryDate"
                    defaultValue={this.getTodayDate()}
                  />
                  <br />
                  <FormGroup>
                    <ControlLabel>* Delivery Time</ControlLabel>
                    <FormControl
                      id={"deliveryTime" + (index + 1)}
                      componentClass="select"
                      placeholder="select"
                    >
                      <option value="09:00 am to 01:00 pm">
                        09:00 am to 01:00 pm
                      </option>
                      <option value="02:00 pm to 06:00 pm">
                        02:00 pm to 06:00 pm
                      </option>
                      <option value="06:00 pm to 09:00 pm">
                        06:00 pm to 09:00 pm
                      </option>
                    </FormControl>
                  </FormGroup>
                </div>
                <Field
                  title="* Delivery Address"
                  name={"deliveryAddress" + (index + 1)}
                  withLabel={true}
                  component={renderTextField}
                />
                <div className="form-group">
                  <FormGroup>
                    <ControlLabel>* Region</ControlLabel>
                    <FormControl
                      id={"subRegion" + (index + 1)}
                      componentClass="select"
                      placeholder="select"
                      name={subRegionListItem}
                      onChange={this.getRegionDeliveryPrice}
                      inputRef={(el) => (this.inputEl = el)}
                    >
                      {subRegionListItem}
                    </FormControl>
                  </FormGroup>
                </div>

                <div id="MessageSection">
                  {/*<Field*/}
                  {/*  dynamicClass="MessageLabel1"*/}
                  {/*  name={"messageTo" + (index + 1)}*/}
                  {/*  value=""*/}
                  {/*  label="* To:"*/}
                  {/*  component={renderTextAreaField}*/}
                  {/*/>*/}
                  <Field
                    dynamicClass="MessageLabel2"
                    name={"messageContent" + (index + 1)}
                    value=""
                    label="Message:"
                    component={renderTextAreaField}
                  />
                  {/*<Field*/}
                  {/*  dynamicClass="MessageLabel1"*/}
                  {/*  name={"messageFrom" + (index + 1)}*/}
                  {/*  value=""*/}
                  {/*  label="* From:"*/}
                  {/*  component={renderTextAreaField}*/}
                  {/*/>*/}
                  {/*<Field
                    name={"hideSenderName" + (index + 1)}
                    label="Hide Sender's Name"
                    component={renderCheckBoxField}
                  /> */}
                </div>

                <Field
                  name={"orderNotes" + (index + 1)}
                  value=""
                  label="Order Notes  to us"
                  component={renderTextAreaField}
                />
              </div>
            );
          } else {
            recipientSectionForm = (
              <div id="RecipientSection">
                <Field
                  name="oneRecipient"
                  label="Same recipient's details for all items"
                  component={renderCheckBoxField}
                  onChange={this.toggleSendAllItem}
                />
                <Field
                  name="oneRecipient"
                  label="Send me a copy of the order"
                  component={renderCheckBoxField}
                  onChange={this.handleCopyOrder}
                />
                <Field
                  name="oneRecipient"
                  label="Send me official receipt"
                  component={renderCheckBoxField}
                  onChange={this.handleOfficialReceipt}
                />
                {this.renderNameSection("* Recipient's Name", "recipient")}
                <Field
                  title="* Phone"
                  name="recipientPhone"
                  withLabel={true}
                  component={renderTextField}
                />
                <Field
                  title="Company"
                  name="recipientCompany"
                  withLabel={true}
                  component={renderTextField}
                />
                <div className="form-group DeliveryDate">
                  <label>* Delivery Date</label>
                  <input
                    id="deliveryDate"
                    className="form-control"
                    name="deliveryDate"
                    type="date"
                    defaultValue={this.getTodayDate()}
                  />
                  <br />
                  <FormGroup>
                    <ControlLabel>* Delivery Time</ControlLabel>
                    <FormControl
                      id="deliveryTime"
                      componentClass="select"
                      placeholder="select"
                    >
                      <option value="09:00 am to 01:00 pm">
                        09:00 am to 01:00 pm
                      </option>
                      <option value="02:00 pm to 06:00 pm">
                        02:00 pm to 06:00 pm
                      </option>
                      <option value="06:00 pm to 09:00 pm">
                        06:00 pm to 09:00 pm
                      </option>
                    </FormControl>
                  </FormGroup>
                </div>
                <Field
                  title="* Delivery Address"
                  name="deliveryAddress"
                  withLabel={true}
                  component={renderTextField}
                />
                <div className="form-group">
                  <FormGroup>
                    <ControlLabel>* Region</ControlLabel>
                    <FormControl
                      id="region"
                      componentClass="select"
                      placeholder="select"
                    >
                      {regionListItem}
                    </FormControl>
                    <FormControl
                      id="subRegion"
                      componentClass="select"
                      placeholder="select"
                    >
                      {subRegionListItem}
                    </FormControl>
                  </FormGroup>
                </div>

                <div id="MessageSection">
                  <Field
                    dynamicClass="MessageLabel1"
                    name="messageTo"
                    value=""
                    label="* To:"
                    component={renderTextAreaField}
                  />
                  <Field
                    dynamicClass="MessageLabel2"
                    name="messageContent"
                    value=""
                    label="Message:"
                    component={renderTextAreaField}
                  />
                  <Field
                    dynamicClass="MessageLabel1"
                    name="messageFrom"
                    value=""
                    label="* From:"
                    component={renderTextAreaField}
                  />
                  {/*<Field
                    name="hideSenderName"
                    label=""
                    component={renderCheckBoxField}
                  />*/}
                </div>

                <Field
                  name="orderNotes"
                  value=""
                  label="Order Notes to us"
                  component={renderTextAreaField}
                />
              </div>
            );
          }

          tabItem.push(
            <Tab
              eventKey={index + 1}
              key={index}
              title={"Item " + (index + 1) + item.product.name}
            >
              {recipientSectionForm}
            </Tab>
          );
        });
      }
    }

    return (
      <div className="ListForm">
        {/*<Prompt
          when={true}
          message='You have unsaved changes, are you sure you want to leave?'
        /> */}
        <form id="payment" onSubmit={handleSubmit(this.onSubmit)}>
          <div className="ListFormLeft">
            <fieldset>
              <legend>Contact Details</legend>
              <div id="ContactSection">
                {this.renderNameSection("* Contact Person", "contact")}
                <Field
                  title="* Email Address"
                  name="contactPersonEmailAddress"
                  withLabel={true}
                  component={renderTextField}
                />
                <Field
                  title="* Phone"
                  name="contactPersonPhone"
                  withLabel={true}
                  component={renderTextField}
                />
              </div>
            </fieldset>

            <fieldset>
              <legend>Recipient Details</legend>
              <Tabs
                id="uncontrolled-tab-example"
                defaultActiveKey={1}
                onSelect={(eventKey) => this.handleSelectItemTab(eventKey)}
              >
                {tabItem}
              </Tabs>
            </fieldset>
          </div>

          <div className="ListFormRight">
            <div>
              <OrderDetail shoppingCartItems={shoppingCartItems} />
            </div>
            <div id="PaymentMethodSection">
              <Cards
                number={this.state.number}
                name={this.state.name}
                expiry={this.state.expiry}
                callback={this.handleCallback}
                style={{ margin: 0 }}
              />

              <div
                style={{ textAlign: "center", marginTop: 20, marginBottom: 20 }}
              >
                <input
                  type="tel"
                  name="number"
                  placeholder="Card Number"
                  onKeyUp={this.handleInputChange}
                  onFocus={this.handleInputFocus}
                  style={{ padding: 5 }}
                />
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  onKeyUp={this.handleInputChange}
                  onFocus={this.handleInputFocus}
                  style={{ padding: 5 }}
                />
                <input
                  type="text"
                  name="expiry"
                  placeholder="00/00"
                  onKeyUp={this.handleInputChange}
                  onFocus={this.handleInputFocus}
                  style={{ padding: 5 }}
                />
              </div>
              {valid ? (
                <button type="submit" className="btn btn-success">
                  CONFIRM ORDER
                </button>
              ) : (
                <button
                  type="submit"
                  disabled={true}
                  className="btn btn-success"
                >
                  PLEASE FILL OUT ALL THE INFORMATION
                </button>
              )}

              <Link to="/order/cartlist">
                <button type="button" className="btn btn-primary">
                  RETURN
                </button>
              </Link>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};

  if (!sendAllItem) {
    let shoppingCartItems = JSON.parse(
      localStorage.getItem("shoppingCartItems")
    );

    // if (!values.contactfirstName)
    //   errors.contactfirstName = "Please fill up your first name";
    // if (!values.contactlastName)
    //   errors.contactlastName = "Please fill up your last name";
    if (!values.contactDisplayName)
      errors.contactDisplayName = "Please fill your name";
    if (!values.contactPersonEmailAddress)
      errors.contactPersonEmailAddress = "Please fill up your email";
    else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
        values.contactPersonEmailAddress
      )
    )
      errors.contactPersonEmailAddress = "Invalid email address";
    if (
      !values.contactPersonPhone ||
      isNaN(values.contactPersonPhone) ||
      values.contactPersonPhone.toString().length < 8
    )
      errors.contactPersonPhone =
        "Invalid Phone Number: Phone number should be 8 digits ";
    // errors.contactPersonPhone = "Please fill up your phone number";
    else if (false) errors.contactPersonPhone = "Invalid phone number";

    _.map(shoppingCartItems, (item, index) => {
      if (!values["recipient" + (index + 1) + "firstName"])
        errors["recipient" + (index + 1) + "firstName"] =
          "Please fill up recipient's first name";
      if (!values["recipient" + (index + 1) + "lastName"])
        errors["recipient" + (index + 1) + "lastName"] =
          "Please fill up recipient's last name";
      if (!values["recipient" + (index + 1) + "DisplayName"])
        errors["recipient" + (index + 1) + "DisplayName"] =
          "Please fill up recipient's name";
      if (
        !values["recipientPhone" + (index + 1)] ||
        isNaN(values["recipientPhone" + (index + 1)]) ||
        values["recipientPhone" + (index + 1)].length < 8
      )
        //errors["recipientPhone" + (index + 1)] =
        // "Please fill up recipient's phone number";
        errors["recipientPhone" + (index + 1)] =
          "Invalid Phone Number: Phone number should be 8 digits ";
      else if (false)
        errors["recipientPhone" + (index + 1)] = "Invalid phone number";
      if (!values["messageTo" + (index + 1)])
        errors["messageTo" + (index + 1)] = "Please fill up field";
      if (!values["messageFrom" + (index + 1)])
        errors["messageFrom" + (index + 1)] = "Please fill up field";

      if (!values["deliveryAddress" + (index + 1)])
        errors["deliveryAddress" + (index + 1)] =
          "Please fill up recipient's delivery address";
      //  if (!values.deliveryAddress)
      //  errors.deliveryAddress = "Please fill up recipient's delivery address";

      if (!values["deliveryDate" + (index + 1)])
        errors["deliveryDate" + (index + 1)] =
          "Please fill up recipient's delivery Date";
    });

    if (!values.cardholderName)
      errors.cardholderName = "Please fill up card holder's name";
    if (!values.cardNumber) errors.cardNumber = "Please fill up card number";
    else if (!/^([0-9]{16})$/i.test(values.cardNumber)) {
      errors.cardNumber = "Invalid card number";
    }
  } else {
    // if (!values.contactfirstName)
    //     //   errors.contactfirstName = "Please fill up your first name";
    //     // if (!values.contactlastName)
    //     //   errors.contactlastName = "Please fill up your last name";
    if (!values.contactDisplayName)
      errors.contactDisplayName = "Please fill your name";
    if (!values.contactPersonEmailAddress)
      errors.contactPersonEmailAddress = "Please fill up your email";
    else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
        values.contactPersonEmailAddress
      )
    )
      errors.contactPersonEmailAddress = "Invalid email address";

    if (
      !values.contactPersonPhone ||
      isNaN(values.contactPersonPhone) ||
      values.contactPersonPhone.toString().length < 8
    )
      errors.contactPersonPhone =
        "Invalid Phone Number: Phone number should be 8 digits ";
    /*if (!values.contactPersonPhone)
      errors.contactPersonPhone = "Please fill up your phone number";
    else if (false) errors.contactPersonPhone = "Invalid phone number";*/
    console.log(values);
    if (!values.recipientDisplayName)
      errors.recipientDisplayName = "Please fill up recipient's first name";
    // if (!values.recipientlastName)
    //   errors.recipientlastName = "Please fill up recipient's last name";
    if (!values.recipient0DisplayName)
      errors.recipient0DisplayName = "Please fill up recipient's name";
    if (
      !values.recipientPhone ||
      isNaN(values.recipientPhone) ||
      values.recipientPhone.toString().length < 8
    )
      errors.recipientPhone =
        "Invalid Phone Number: Phone number should be 8 digits ";
    // else if (false) errors.recipientPhone = "Invalid phone number";

    // if(!values.messageTo)
    //   errors.messageTo = "Please add field"
    //
    // if(!values.messageFrom)
    //   errors.messageFrom = "Please add field"

    if (!values.deliveryDate) {
      errors.deliveryDate = "Please fill delivery date";
    }

    if (!values.deliveryAddress)
      errors.deliveryAddress = "Please fill up recipient's delivery address";

    if (!values.cardholderName)
      errors.cardholderName = "Please fill up card holder's name";
    if (!values.cardNumber) errors.cardNumber = "Please fill up card number";
    else if (!/^([0-9]{16})$/i.test(values.cardNumber))
      errors.cardNumber = "Invalid card number";
  }
  return errors;
}

function mapStateToProps(state) {
  return {
    userToken: state.userToken,
    regionPrice: state.region,
  };
}

export default reduxForm({
  validate,
  form: "ListForm",
})(
  connect(mapStateToProps, {
    fetchUserToken,
    fetchRegion,
    fetchPlace,
    fetchRegionPrice,
  })(ListForm)
);



// WEBPACK FOOTER //
// ./src/components/orderPage2/listForm.js